import { Component } from "react";
import { ProductUUID } from "namirasoft-api-product";
import { NSALoginPage } from "namirasoft-account-react";

class LoginPage extends Component
{
    override render()
    {
        return <NSALoginPage product_id={ProductUUID.NAMIRASOFT_CONTAINER_REGISTRY} />
    }
}

export default LoginPage;